import { IdentityUser } from "@voxmedia/duet-context/context/auth-context";
import {
  NotificationsRootStore as NotificationsRootStoreType,
  NotificationsStore as NotificationsStoreType,
  AllNotificationsStore as AllNotificationsStoreType,
  UnreadNotificationsStore as UnreadNotificationsStoreType,
  UserStore as UserStoreType,
} from "@voxmedia/duet-context/context/notifications-context";

import AllNotificationsStore from "./AllNotificationsStore";
import NotificationsStore from "./NotificationsStore";
import UnreadNotificationsStore from "./UnreadNotificationsStore";
import UserStore from "./UserStore";

class NotificationsRootStore implements NotificationsRootStoreType {
  public notificationsStore: NotificationsStoreType;
  public allNotificationsStore: AllNotificationsStoreType;
  public unreadNotificationsStore: UnreadNotificationsStoreType;
  public userStore: UserStoreType;

  public constructor(user: IdentityUser) {
    this.userStore = new UserStore(user); // TODO: add user
    this.notificationsStore = new NotificationsStore(this.userStore);
    this.allNotificationsStore = new AllNotificationsStore(
      this.userStore,
      this.notificationsStore,
    );
    this.unreadNotificationsStore = new UnreadNotificationsStore(
      this.userStore,
      this.notificationsStore,
    );
  }
}

export default NotificationsRootStore;
